import React from 'react';

export default function Contact() {
    return (
        <div className="container relative">
            <div className="max-w-3xl mx-auto bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-8 text-center">
                <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">İLETİŞİM</h6>
                <h4 className="mb-4 md:text-3xl text-2xl font-bold">İletişime geçin !</h4>
                <p className="text-slate-500 dark:text-slate-300 leading-relaxed mb-6">
                    İletişim formu geçici olarak devre dışı. Uygulama ile ilgili soru, öneri veya yaşadığınız sorunları doğrudan e-posta ile iletebilirsiniz.
                </p>
                <a
                    href="mailto:gudersamet@gmail.com?subject=HatimTakip%20İletişim"
                    className="inline-flex items-center justify-center px-6 py-3 rounded-md bg-red-500 hover:bg-red-600 text-white font-medium transition"
                >
                    E-posta Gönder (gudersamet@gmail.com)
                </a>
                <p className="text-xs text-slate-400 mt-4">Lütfen e-postanızda adınızı ve konuyu belirtin.</p>
            </div>
        </div>
    );
}
